import {Component, Inject, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
    selector: 'generate-voucher-dialog',
    templateUrl: 'generate-voucher-dialog.component.html',
    styleUrls: ['generate-voucher-dialog.component.scss']
})
export class GenerateVoucher implements OnInit {
    voucher:string
    required:any=[]
    error:any=[]
    userId:any
    is_abonnement:any
    voucherFormGroup:FormGroup
    subscribe:any=[]
    message: any;
    success: any = [];
    messageSend: any;
    validemail: boolean;
    regexMail : RegExp = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

    constructor(
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
        public dialogRef: MatDialogRef<GenerateVoucher>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

    }

    ngOnInit() {
        this.voucher = this.data.voucher
        this.userId = this.data.userId
        this.is_abonnement = this.data.is_abonnement
        this.voucherFormGroup = this.formBuilder.group({
            destinataire: new FormControl("",Validators.pattern(this.regexMail)),
            commentaire: new FormControl("")
        });
    }


    validate(){
        let destinataire = this.voucherFormGroup.get("destinataire").value
        if(destinataire !== '' && this.voucherFormGroup.get('destinataire').hasError('pattern')){
            this.error['destinataire'] = true
        }else{
            this.createCoupon(false)
        }
    }

    checkMail(event){
        this.validemail = this.regexMail.test(event.target.value) ? true : false ;
    }


    validateAndSend(){
        let destinataire = this.voucherFormGroup.get("destinataire").value
        if(destinataire === ''){
            this.required['destinataire'] = true
        }else if(this.voucherFormGroup.get('destinataire').hasError('pattern')){
            this.error['destinataire'] = true
        }else{
            this.createCoupon(true)
        }
    }

    createCoupon(send){
        this.required['destinataire'] = false
        this.error['destinataire'] = false
        let dest = this.voucherFormGroup.get("destinataire").value ? this.voucherFormGroup.get("destinataire").value : ''
        let comm = this.voucherFormGroup.get("commentaire").value ? this.voucherFormGroup.get("commentaire").value : ''

        console.log(this.userId, this.voucher,dest,comm, send)
        if(this.subscribe && this.subscribe['createCoupon']){
            this.subscribe['createCoupon'].unsubscribe();
        }
        
        this.subscribe['createCoupon'] = this.customerService.createCoupon(this.userId, this.is_abonnement, this.voucher,dest,comm, send).subscribe((res)=>{
            console.log(res)
            if(res && res.result &&  res.result.message){
                this.message = res.result.message
                this.success['create'] = res.result.success ? true : false
            }
            if(send && res && res.result && res.result['message-send']){
                this.messageSend =res.result['message-send']
                this.success['send'] = res.result['success-send'] ? true : false
            }
            
        })

    }

    dismissDialog(){
        if(this.success && this.success.create)
            this.dialogRef.close({create:true})
        else
            this.dialogRef.close({create:false})
    }
}